import React, { useCallback } from 'react';
import { FolderManager } from './FolderManager';
import { useFolderManagerActions } from '../../hooks/useFolderManagerActions';
import {
  FolderManagerAction,
  FolderManagerActionTypes,
  FolderManagerBreadcrumb,
  FolderManagerMimeTypes,
  FolderManagerViewTypes,
} from '../../interfaces';

interface FolderManagerWithActionsProps {
  isLoading: boolean;
  fileInputRef?: any;
  rootFolderId: number;
  noDataMessage?: string;
  selectedFolderId?: any;
  selectedFolderData?: any;
  slug?: string;
  rootFolder?: any;
  viewStateKey?: string;
  availableViews?: (FolderManagerViewTypes.SLIDES | FolderManagerViewTypes.GRID | FolderManagerViewTypes.LIST)[];
  enableZoomControls?: boolean;
  isSlideRepository?: boolean;
  showThemePicker?: boolean;

  hierarchyData: FolderManagerItem[];
  breadcrumbs: FolderManagerBreadcrumb[];
  disableUpload?: boolean;
  defaultViewType?: FolderManagerViewTypes;
  newButtonActionType?: string | null;
  minHeight?: string;
  acceptedDragTypes?: FolderManagerMimeTypes[];
  stickyHeaderTop?: number;

  onClearNewButtonAction: () => void;
  customMultiSelectActions?: (data: {
    selectedItems: any[];
    onClear: () => void;
    onAction?: FolderManagerAction;
  }) => void;
  onAction?: (data: FolderManagerAction) => void;
  onSelect?: (data: { selectedRows: FolderManagerItem[]; clearSelection: () => void }) => void;
  allowEntityClick?: boolean;
  disableActionColumn?: boolean;
  disableInternalDnD?: boolean;

  customActionHandlers?: Partial<
    Record<FolderManagerActionTypes, (action: FolderManagerAction) => void | Promise<void>>
  >;
  onActionSuccess?: (actionType: FolderManagerActionTypes) => void;
  onActionError?: (actionType: FolderManagerActionTypes, error: any) => void;
}

export const FolderManagerWithActions: React.FC<FolderManagerWithActionsProps> = ({
  slug,
  selectedFolderId,
  selectedFolderData,
  rootFolder,
  customActionHandlers,
  onAction,
  onActionSuccess,
  onActionError,
  ...folderManagerProps
}) => {
  const { handleAction, dialogs } = useFolderManagerActions({
    slug,
    selectedFolderId,
    selectedFolderData,
    rootFolder,
    customActionHandlers,
    onActionSuccess,
    onActionError,
  });

  const combinedActionHandler = useCallback(
    (action: FolderManagerAction) => {
      handleAction(action);

      if (onAction) {
        onAction(action);
      }
    },
    [handleAction, onAction],
  );

  return (
    <>
      <FolderManager {...folderManagerProps} selectedFolderId={selectedFolderId} onAction={combinedActionHandler} />
      {dialogs}
    </>
  );
};
